import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { type ReactElement } from 'react'

import { ModalId } from '../../../../enums/modalId'
import { InvoicingSettingsHostContextProvider } from '../../contexts/invoicingSettingsHostContext'
import type { InvoicingSettingsEntryContext } from '../../enums/invoicingSettingsEntryContext'
import { InvoicingSettingsSection } from '../../enums/invoicingSettingsSection'
import { InvoicingSettingsModalContent } from './elements/InvoicingSettingsModalContent'
import { UnsavedChangesModal } from './elements/UnsavedChangesModal'

interface InvoicingSettingsModalProps extends ModalProps {
  entryContext?: InvoicingSettingsEntryContext
  initialSection?: InvoicingSettingsSection
}

const InvoicingSettingsModalComponent = ({
  entryContext,
  initialSection,
  ...modalProps
}: InvoicingSettingsModalProps): ReactElement => (
  <InvoicingSettingsHostContextProvider
    entryContext={entryContext}
    initialSection={initialSection}
    modalId={modalProps.id}
  >
    <Modal {...modalProps} closable={false} size="fullScreen">
      <InvoicingSettingsModalContent id={modalProps.id} />
    </Modal>
    <UnsavedChangesModal id={ModalId.InvoicingSettingsUnsavedChangesModal} />
  </InvoicingSettingsHostContextProvider>
)

export const InvoicingSettingsModal = withModalConditionalRender(InvoicingSettingsModalComponent)
